export const FollowupModes = {
    EDIT_CURRENT: 'Edit current',
    EDIT_NEW: 'Edit new',
    EDIT_CURRENT_AND_NEW: 'Edit current and new',
    DIRECT_STATUS_UPDATE: 'Direct status update'
};